import { render, staticRenderFns } from "./FixedWidthContainer.vue?vue&type=template&id=325312cd&lang=pug&functional=true&"
import script from "./FixedWidthContainer.vue?vue&type=script&lang=js&"
export * from "./FixedWidthContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports